import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import myExtendedInsuranceDetails from './views/my-extended-insurance-details'
import myExtendedInsurance from './views/my-extended-insurance'
import myExtendedInsuranceBriefIntroduction from './views/my-extended-insurance-brief-introduction'

export default [
  {
    path: RoutePathConstants.MY_EXTENDED_INSURANCE,
    name: 'myExtendedInsurance',
    component: myExtendedInsurance
  },
  {
    path: RoutePathConstants.MY_EXTENDED_INSURANCE_DETAILS,
    name: 'myExtendedInsuranceDetails',
    component: myExtendedInsuranceDetails
  },
  {
    path: RoutePathConstants.MY_EXTENDED_INSURANCE_BRIEF_INTRODUCTION,
    name: 'myExtendedInsuranceBriefIntroduction',
    component: myExtendedInsuranceBriefIntroduction
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-extended-insurance/routers.js